var modules_1e09d314 = {"container":"_1y78ild","active":"_evp4jy","size-36":"_18bq52s","size-44":"_rb8e79","background-dark":"_opv730","background-light":"_3p6e3j"};
import "../../../assets/DB8iZQv_.css";

export { modules_1e09d314 as default };
//# sourceMappingURL=Tag.module.less.js.map
